import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
// import { Manager, Target, Popper } from "react-popper";

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// import MenuItem from '@material-ui/core/MenuItem'
// import MenuList from '@material-ui/core/MenuList'
// import ClickAwayListener from '@material-ui/core/ClickAwayListener'
// import Paper from '@material-ui/core/Paper'
// import Grow from '@material-ui/core/Grow'
import Hidden from '@material-ui/core/Hidden'
// import Popper from '@material-ui/core/Popper'

// @material-ui/icons
import ExitToApp from '@material-ui/icons/ExitToApp'
import Dashboard from '@material-ui/icons/Dashboard'
import Search from '@material-ui/icons/Search'
import Undo from '@material-ui/icons/Undo'

// core components
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import Button from 'components/CustomButtons/Button.jsx'
// import Badge from 'components/Badge/Badge.jsx'

import headerLinksStyle from 'assets/jss/material-dashboard-pro-react/components/headerLinksStyle'
import AppContext from '../../services/context'

class HeaderLinks extends React.Component {
  static contextType = AppContext
  state = {
    open: false,
    searchText: ''
  }
  //static contextType = AppContext
  handleClick = () => {
    this.setState({ open: !this.state.open })
  }
  handleClose = () => {
    this.setState({ open: false })
  }

  change(event, stateName) {
    this.setState({
      [stateName]: event.target.value
    })
    // console.log(this.state)
  }
  render() {
    // console.log(this.props)
    const { classes, rtlActive } = this.props
    // const { open } = this.state
    const searchButton =
      classes.top +
      ' ' +
      classes.searchButton +
      ' ' +
      classNames({
        [classes.searchRTL]: rtlActive
      })
    // const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover, { [classes.dropdownItemRTL]: rtlActive })
    const wrapper = classNames({
      [classes.wrapperRTL]: rtlActive
    })
    // const managerClasses = classNames({
    //   [classes.managerClasses]: true
    // })

    //console.log(this.context)
    return (
      <div className={wrapper}>
        {/* <AppContext.Consumer>{context => console.log(context)}</AppContext.Consumer> */}

        <CustomInput
          rtlActive={rtlActive}
          formControlProps={{
            className: classes.top + ' ' + classes.search
          }}
          inputProps={{
            onChange: event => this.change(event, 'searchText'),
            placeholder: 'Search',
            'aria-label': 'Search',
            className: classes.searchInput
          }}
        />
        <Button
          color='white'
          aria-label='edit'
          justIcon
          round
          className={searchButton}
          onClick={() => {
            // console.log(this.state.searchText, this.context.user.id)
            // this.props.history.push({ pathname: '/applications/searched', textSearch: this.state.searchText, userId: this.context.user.id })
          }}
        >
          <Search className={classes.headerLinksSvg + ' ' + classes.searchIcon} />
        </Button>
        <Button
          color='transparent'
          simple
          aria-label='Dashboard'
          justIcon
          className={classes.buttonLink}
          muiClasses={{
            label: ''
          }}
          onClick={() => {
            this.props.history.push('/dashboard')
          }}
        >
          <Dashboard className={classes.headerLinksSvg + ' ' + classes.links} />
          <Hidden mdUp implementation='css'>
            <span className={classes.linkText}>{'Dashboard'}</span>
          </Hidden>
        </Button>
        {/* <div className={managerClasses}>
          <Button
            color="transparent"
            justIcon
            aria-label="Notifications"
            aria-owns={open ? 'menu-list' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
            className={classes.buttonLink}
            muiClasses={{
              label: ''
            }}
            buttonRef={node => {
              this.anchorOfNotification = node
            }}
          >
            <Notifications className={classes.headerLinksSvg + ' ' + classes.links} />
            <span className={classes.notifications}>5</span>
            <Hidden mdUp implementation="css">
              <span onClick={this.handleClick} className={classes.linkText}>
                {'Notification'}
              </span>
            </Hidden>
          </Button>
          <Popper
            open={open}
            anchorEl={this.anchorOfNotification}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !open,
              [classes.pooperResponsive]: true,
              [classes.pooperNav]: true
            })}
          >
            {({ TransitionProps, placement }) => (
              <Grow {...TransitionProps} id="menu-list" style={{ transformOrigin: '0 0 0' }}>
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList role="menu">
                      <MenuItem onClick={this.handleClose} className={dropdownItem}>
                        {'Mike John responded to your email'}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose} className={dropdownItem}>
                        {'You have 5 new tasks'}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose} className={dropdownItem}>
                        {"You're now friend with Andrew"}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose} className={dropdownItem}>
                        {'Another Notification'}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose} className={dropdownItem}>
                        {'Another One'}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div> */}
        <Button
          color='transparent'
          simple
          aria-label='Dashboard'
          justIcon
          className={classes.buttonLink}
          muiClasses={{
            label: ''
          }}
          onClick={() => this.props.history.goBack()}
        >
          <Undo className={classes.headerLinksSvg + ' ' + classes.searchIcon} />
        </Button>

        <Button
          color='transparent'
          aria-label='Person'
          justIcon
          className={classes.buttonLink}
          muiClasses={{
            label: ''
          }}
          buttonRef={node => {
            this.anchorOfPerson = node
          }}
          onClick={() => {
            this.context = { isAuthenticated: false }
            localStorage.removeItem('token')
            this.props.history.push('/login')
          }}
        >
          <ExitToApp className={classes.headerLinksSvg + ' ' + classes.links} />
          {/* <Hidden mdUp implementation="css">
            <span className={classes.linkText}>{'Profile'}</span>
          </Hidden> */}
        </Button>
      </div>
    )
  }
}
//HeaderLinks.contextType = AppContext
HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
}

const temp = withStyles(headerLinksStyle)(HeaderLinks)
export default withRouter(temp)
